// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downloadBOMIcon[data-v-683cbf06]{height:70px;margin:15px;width:auto}.modalBody[data-v-683cbf06]{padding:20px}#id_def_modal___BV_modal_outer_[data-v-683cbf06]{z-index:1100!important}", ""]);
// Exports
module.exports = exports;
